import React from "react";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";
import { SectionHeading } from "../../atoms/SectionHeading";
import DownloadIcon from "../../../../assets/icons/download";
import { getLinkTarget } from "../../../arrow/utils/utils";
import "./event-outcomes.m.css";

export const EventOutcomes = ({
    footnote,
    conclusionPaper = {},
    presentations = [],
    showReadNow = false,
    presentationsTitle = ""
}) => {
    return (
        <div styleName="event-outcomes" data-section="outcome">
            <div styleName="section-heading" id="outcomes-heading">
                <SectionHeading>Outcomes</SectionHeading>
            </div>

            {conclusionPaper?.url && conclusionPaper?.url !== "#" && (
                <div styleName="conclusion-paper-section">
                    <div styleName="conclusion-box">
                        <div styleName="conclusion-wrapper">
                            <div styleName="conclusion-content">
                                <h3 styleName="label" dangerouslySetInnerHTML={{ __html: conclusionPaper?.title }} />
                                <div styleName="conclusion-text" dangerouslySetInnerHTML={{ __html: conclusionPaper?.description }} />
                            </div>
                            {showReadNow && (
                                <div styleName="btn-wrapper">
                                    {conclusionPaper?.url?.startsWith("/") ? (
                                        <Link href={conclusionPaper?.url} styleName="read-now-btn" target={getLinkTarget(conclusionPaper?.url)} rel="noopener">
                                            Read now
                                        </Link>
                                    ) : (
                                        <a href={conclusionPaper?.url} styleName="read-now-btn" target={getLinkTarget(conclusionPaper?.url)} rel="noopener noreferrer">
                                            Read now
                                        </a>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {presentations && presentations.length > 0 && (
                <div styleName="presentations-section">
                    <div styleName="presentation-list-wrapper">
                        <h3 styleName="label" dangerouslySetInnerHTML={{ __html: presentationsTitle }} />
                        <div styleName="presentation-list">
                            {presentations.map((item, index) => (
                                <div key={index} styleName="presentation-item">
                                    <div styleName="presentation-info">
                                        <div styleName="presentation-title" dangerouslySetInnerHTML={{ __html: item.title }} />
                                        {item.speakers && (Array.isArray(item.speakers) ? item.speakers : [item.speakers]).filter(Boolean).length > 0 && (
                                            <div styleName="presentation-speakers">
                                                {(Array.isArray(item.speakers) ? item.speakers : [item.speakers]).filter(Boolean).map((speaker, i) => (
                                                    <React.Fragment key={i}>
                                                        {i > 0 && <span styleName="speaker-divider" aria-hidden="true" />}
                                                        <span dangerouslySetInnerHTML={{ __html: speaker }} />
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    {item.pdfUrl && item.pdfUrl !== "#" && (
                                        <a href={item.pdfUrl} styleName="download-link" target={getLinkTarget(item.pdfUrl)} rel="noopener noreferrer">
                                            <DownloadIcon />
                                        </a>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {footnote && <div styleName="footnote" dangerouslySetInnerHTML={{ __html: footnote }} />}
        </div>
    );
};

EventOutcomes.propTypes = {
    conclusionPaper: PropTypes.shape({
        description: PropTypes.string,
        title: PropTypes.string,
        url: PropTypes.string,
    }),
    presentations: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            speakers: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.arrayOf(PropTypes.string),
            ]),
            pdfUrl: PropTypes.string,
        })
    ),
    showReadNow: PropTypes.bool,
    footnote: PropTypes.string,
    presentationsTitle: PropTypes.string,
};
